<!-- Footer Area -->
<footer class="footer-area pt-100 pb-70">
    <div class="container">
        <div class="row">
            <div class="col-lg-4 col-md-6">
                <div class="footer-widget">
                    <div class="footer-logo">
                        <a routerLink="/"><img src="assets/img/mpa.png" alt="Images"></a>
                    </div>
                    <p>My Professional Accountants offers expert accounting and consultancy services to help businesses
                        achieve financial success.</p>
                    <ul class="social-link">
                        <!-- <li><a href="#" target="_blank"><i class='bx bxl-facebook'></i></a></li> -->
                        <!-- <li><a href="#" target="_blank"><i class='bx bxl-twitter'></i></a></li> -->
                        <!-- <li><a href="#" target="_blank"><i class='bx bxl-instagram'></i></a></li> -->
                        <li><a href="https://wa.me/27686715057" target="_blank"><i class='bx bxl-whatsapp'></i></a></li>
                        <li><a href="mailto:marium&#64;mpaconsultants.co.za" target="_blank"><i
                                    class='bx bxs-envelope'></i></a></li>
                    </ul>
                </div>
            </div>

            <div class="col-lg-2 col-md-6">
                <div class="footer-widget">
                    <h3>Useful Links</h3>

                    <ul class="footer-list">
                        <li><a routerLink="/about">About Us</a></li>
                        <li><a routerLink="/services">Services</a></li>
                        <li><a routerLink="/blogs">Blogs</a></li>
                        <li><a routerLink="/faq">FAQs</a></li>
                    </ul>
                </div>
            </div>

            <div class="col-lg-3 col-md-6">
                <div class="footer-widget">
                    <h3>Contact Us</h3>

                    <ul class="footer-list-two">
                        <li>
                            <i class='bx bx-time'></i>
                            Mon - Fri: 8am - 5pm
                        </li>
                        <li>
                            <i class='bx bx-location-plus'></i>
                            32 Ivor St, Gillview, Jhb
                        </li>
                        <li>
                            <i class='bx bx-phone'></i>
                            <a href="tel:+61283171380">+27 84 900 4590</a>
                        </li>
                        <li>
                            <i class='bx bxl-whatsapp'></i>
                            <a href="https://wa.me/27686715057">WhatsApp</a>
                        </li>
                        <li>
                            <i class='bx bxs-envelope'></i>
                            <a href="mailto:info&#64;gloz.com">marium&#64;mpaconsultants.co.za</a>
                        </li>
                    </ul>
                </div>
            </div>

            <div class="col-lg-3 col-md-6">
                <div class="footer-widget pl-2">
                    <h3>Contacts</h3>

                    <div class="newsletter-area">
                        <form class="newsletter-form">
                            <input type="email" class="form-control" placeholder="Your Email*" name="EMAIL">
                            <button class="default-btn" type="submit">Subscribe </button>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</footer>
<!-- Footer Area End -->

<!-- Copy-Right Area -->
<div class="copy-right-area">
    <div class="container">
        <div class="copy-right-text text-center">
            <p>© 2024 copyright <a href="">My Professional Accountants.</a> All rights reserved</p>
        </div>
    </div>
</div>
<!-- Copy-Right Area End -->